import Footer from '../../components/Footer';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Container, GamesContainer, Row, SearchBar } from './styles';
import { Card as CustomCard } from './components/Card';
import { Header } from './components/Header';
import { useEffect, useState } from 'react';
import { apiNode } from '../../services/api';
import { JoinLeagueModal } from './components/JoinLeagueModal';
import { Card } from 'antd';
import { CreateLeagueModal } from './components/CreateLeagueModal';
import { FiPlus, FiSearch } from 'react-icons/fi';
import { normalizeString } from '../../utils/normalizeString';

interface LeagueProps {
  id: number;
  nome: string;
  privada: boolean;
  createdAt: string;
}

interface LeagueAPIResponse {
  liga: LeagueProps;
  num_participantes: number;
}

interface LeaguesProps {
  updateHasLeague: () => Promise<void>;
}

export const Leagues: React.FC<LeaguesProps> = ({
  updateHasLeague,
}: LeaguesProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [leagues, setLeagues] = useState<LeagueAPIResponse[]>([]);
  const [leagueName, setLeagueName] = useState('');
  const [filteredLeagues, setFilteredLeagues] = useState<LeagueAPIResponse[]>(
    []
  );

  const [isJoinLeagueModalOpen, setIsJoinLeagueModalOpen] = useState(false);
  const [isCreateLeagueModalOpen, setIsCreateLeagueModalOpen] = useState(false);
  const [selectedLeague, setSelectedLeague] = useState<LeagueProps>(
    {} as LeagueProps
  );

  useEffect(() => {
    try {
      setIsLoading(true);
      const getLeagues = async () => {
        const response = await apiNode.get('/ligas');

        setFilteredLeagues(response.data.ligas);
        setLeagues(response.data.ligas);
        setIsLoading(false);
      };

      getLeagues();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    let newLeaguesList: LeagueAPIResponse[] = [];
    leagues.forEach((league) => {
      if (
        normalizeString(league.liga.nome).includes(normalizeString(leagueName))
      ) {
        newLeaguesList.push(league);
      }
    });

    setFilteredLeagues(newLeaguesList);
  }, [leagueName, leagues]);

  const openJoinLeagueModal = (league: LeagueProps) => {
    setIsJoinLeagueModalOpen(true);
    setSelectedLeague(league);
  };

  return (
    <Container>
      <Header />
      <GamesContainer>
        <Row>
          <span>
            <h2>Ligas</h2>

            <SearchBar>
              <FiSearch size={15} />
              <input
                type="text"
                placeholder="Encontre uma Liga"
                onChange={(event) => setLeagueName(event.target.value)}
              />
            </SearchBar>
          </span>

          <div>
            {isLoading && (
              <>
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
                <Card
                  loading={true}
                  style={{ width: '80%', marginRight: 36 }}
                />
              </>
            )}

            {!isLoading &&
              filteredLeagues.length > 0 &&
              filteredLeagues.map((league) => (
                <CustomCard
                  key={league.liga.id}
                  league={league}
                  openJoinLeagueModal={openJoinLeagueModal}
                />
              ))}

            {!isLoading && filteredLeagues.length < 1 && (
              <h1>Nenhuma liga disponível</h1>
            )}
          </div>
        </Row>
        <button type="button" onClick={() => setIsCreateLeagueModalOpen(true)}>
          <p>Criar liga</p>

          <FiPlus size={25} />
        </button>
      </GamesContainer>
      <Footer />

      <JoinLeagueModal
        isOpen={isJoinLeagueModalOpen}
        league={selectedLeague}
        closeModal={() => setIsJoinLeagueModalOpen(false)}
        updateHasLeague={updateHasLeague}
      />

      <CreateLeagueModal
        isOpen={isCreateLeagueModalOpen}
        closeModal={() => setIsCreateLeagueModalOpen(false)}
        updateHasLeague={updateHasLeague}
      />
    </Container>
  );
};
